// While the account's inbox has unread items the badge stays on, so the
// visibility reset below must not strip it when the tab comes back.
let keepBadge = false;
// Bump when the badge art changes; the PNGs are served with a 1-year max-age.
const BADGE_VERSION = 2;

const swapFavicons = badged => {
  document.querySelectorAll('.favicon').forEach(favicon => {
    const size = favicon.sizes[[0]];
    favicon.href = badged
      ? `/favicon-badge-${size}.png?v=${BADGE_VERSION}`
      : `/favicon-${size}.png`;
  });
};

export const showBadgeOnFavicon = () => swapFavicons(true);

export const setInboxFaviconBadge = hasUnread => {
  keepBadge = hasUnread;
  swapFavicons(hasUnread);
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && !keepBadge) {
      swapFavicons(false);
    }
  });
};
